module.exports = __webpack_public_path__ + "img/EurMillions_Ad1.8c4547f4.png";